export default {"src":"/_next/static/media/harness-logo.375800ec.svg","height":75,"width":315};